import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';


const Container = styled.div`
  margin: 50px;
  padding: 2rem;
  background: #fff;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  border-radius: 8px;

  @media (max-width: 768px) {
    text-align: center;
  }
`;

const Button = styled.button`
  background-color: #385963;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 2rem;
  place-self: center;

  &:hover {
    background-color: #2c4a52;
  }

 @media (max-width: 768px) {
   margin-top:0px;
  }
`;

const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 25px;
  }
`;

const Title = styled.h2`
  color: #385963;
   @media (max-width: 768px) {
   margin-top:10px;
    18px;
  }
`;

const BackButton = styled.button`
  background: none;
  border: 1px solid #385963;
  color: #385963;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;

  &:hover {
    background-color: #f0f0f0;
  }

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  
`;

const FieldWrapper = styled.div``;

const FieldTitle = styled.h4`
  margin-bottom: 1rem;
  color: #385963;
`;


const LangRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FieldGroup = styled.div`
  margin-bottom: 1.5rem;

  label {
    display: block;
    font-weight: bold;
    margin-bottom: 0.5rem;
    color: #385963;
  }

  input, textarea {
    width: 100%;
    padding: 0.75rem;
    border: 1px solid #ccc;
    border-radius: 6px;
    font-size: 1rem;
  }

  textarea {
    resize: vertical;
    min-height: 100px;
  }
`;

const AddCategory = () => {
  const { categoryType } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = sessionStorage.getItem("token");

  const [form, setForm] = useState({
    name: {
      en: '',
      gr: ''
    },
    description: {
      en: '',
      gr: ''
    }
  });

  const handleChange = (field, lang, value) => {
    setForm(prev => ({
      ...prev,
      [field]: {
        ...prev[field],
        [lang]: value
      }
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const endpoint = `${BASE_URL}${categoryType}Category`;

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(form)
      });

      if (!res.ok) throw new Error('Failed to add category');

      alert(t('categoryAdded') || 'Category added successfully');
      navigate(`/admin/all-categories-admin`);
    } catch (err) {
      console.error(err);
      alert(t('errorAddingCategory') || 'Something went wrong');
    }
  };

  return (
    <Container>

        <TopBar>
            <BackButton onClick={() => navigate('/admin/all-categories-admin')}>
            ← {t('backToCategories')}
            </BackButton>
            <Title>{t('add')} {t(`${categoryType}Category`)}</Title>
        </TopBar>

        <form onSubmit={handleSubmit}>
        <FormWrapper>
          {['name', 'description'].map((field) => (
          <FieldWrapper key={field}>
              <FieldTitle>{t(field)}</FieldTitle>
              <LangRow>
                  <FieldGroup>
                  <label>{t(field)} (Ελληνικά)</label>
                  {field === 'description' ? (
                      <textarea
                      value={form[field].gr}
                     onChange={(e) => handleChange(field, 'gr', e.target.value)}
                      required
                      />
                  ) : (
                      <input
                      type="text"
                      value={form[field].gr}
                     onChange={(e) => handleChange(field, 'gr', e.target.value)}
                      required
                      />
                  )}
                  </FieldGroup>  
                  <FieldGroup>
                  <label>{t(field)} (English)</label>
                  {field === 'description' ? (
                      <textarea
                      value={form[field].en}
                     onChange={(e) => handleChange(field, 'en', e.target.value)}
                      required
                      />
                  ) : (
                      <input
                      type="text"
                      value={form[field].en}
                      onChange={(e) => handleChange(field, 'en', e.target.value)}
                      required
                      />
                  )}
                  </FieldGroup>
              </LangRow>
          </FieldWrapper>
          ))}

         <Button type="submit">{t('addCategory')}</Button>
         
        </FormWrapper>
        </form>
    </Container>
  );
};

export default AddCategory;
